import { useEffect, useState } from 'react';

export function useMediaQuery(query: string) {
    // Read the query up front rather than defaulting to false: a first render that assumes the
    // query does not match flashes the wrong UI and misleads any effect that reads this on mount.
    const [matches, setMatches] = useState<boolean>(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mql = window.matchMedia(query);

        const onChange = (event: MediaQueryListEvent) => {
            setMatches(event.matches);
        };
        mql.addEventListener('change', onChange);

        setMatches(mql.matches);

        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
